// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"27bba703","952":"8800437b"}[chunkId] + ".chunk.js";
};